import {
    Component,
    OnInit
} from '@angular/core';
import {
    ActivatedRoute,
    Router
} from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowCspService } from '../workflow-csp.service';
import { firstValueFrom } from 'rxjs';
import { WorkflowComponent } from '../../workflow.component';
import { SaleOrder } from 'src/app/buy/buy.model';


@Component({
    selector: 'app-workflow-csp-one-availability-order-cancel',
    templateUrl: './workflow-csp-one-availability-order-cancel.component.html',
    standalone: false
})
export class WorkflowCspOneAvailabilityOrderCancelComponent extends WorkflowComponent implements OnInit {

    public subscription: Subscription;
    public readonly productPremium = "PC-ONE-PREMIUM";
    public readonly productCancelPremium = "PC-ONE-CANCEL-PREMIUM";

    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowCsp: WorkflowCspService
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.setStep('order-cancel');
        if (!this.applianceId) {
            return;
        }

        this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
            next: (r) => {
                this.subscription = Subscription.fromJson(r);
                this.applianceId = this.subscription.appliance_id;
                this.setStep('order-cancel');
            },
            error: (err) => {
                console.error('Failed to load subscription:', err);
            }
        });
    }

    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        let hasPremium: boolean = false;
        let orderFound: SaleOrder;
        try {
            for (const order of this.subscription?.orders ?? []) {
                hasPremium = (order?.lines ?? []).some(
                    line => (line?.product === this.productPremium)
                        || (line?.product === this.productCancelPremium)
                );
                if(hasPremium){
                    orderFound = order;
                    break;
                }
            }
            if (hasPremium) {
                await firstValueFrom(this.workflowCsp.oneApplianceCancelPremium(orderFound.name));
                this.resetWorkflow();
            }
        } catch (e) {
            console.error('Cancel premium failed', e);
            this.resetWorkflow();
        }

    }
}
